module.exports = __webpack_public_path__ + "img/b547c55dec4915d0557e2f74f2b95240.png";